globalThis.RenaoReadCartJson ||= async (response) => {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch (error) {
    console.error('Renao cart returned a non-JSON response.', {
      status: response.status,
      url: response.url,
      contentType: response.headers.get('Content-Type') || '',
      preview: text.slice(0, 240),
    });
    throw new Error(response.ok ? 'Sepet yanıtı okunamadı. Lütfen tekrar deneyin.' : `Sepet servisi ${response.status} hatası verdi.`);
  }
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this._renaoSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (globalThis.RenaoCartProgress.uncertain(this.form)) {
          globalThis.RenaoCartProgress.begin(this.form);
          globalThis.RenaoCartProgress.fail(this.form, 'Önce sepetinizi kontrol edin.', true);
          globalThis.RenaoCartProgress.finish(this.form);
          return;
        }
        this._renaoSubmitting = true;
        this._renaoDraftOnly = Boolean(evt.submitter?.hasAttribute('data-renao-save-draft'));
        this.error = false;
        globalThis.RenaoCartProgress.begin(this.form);
        try {
          await this.submitWithRenaoProgress(evt);
        } catch (error) {
          this.error = true;
          this.handleErrorMessage(error?.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
        } finally {
          globalThis.RenaoCartProgress.finish(this.form);
          this._renaoUnlock?.();
          this._renaoUnlock = null;
          this._renaoDraftOnly = false;
          this._renaoSubmitting = false;
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          if (!this.form.__renaoCartUncertain && !this.variantIdInput.disabled) this.submitButton.removeAttribute('aria-disabled');
        }
      }

      renaoRequest(url, options = {}) {
        const pathname = new URL(url, window.location.href).pathname;
        const method = (options.method || 'GET').toUpperCase();
        let label = method === 'GET' ? 'Sepetiniz doğrulanıyor'
          : /\/cart\/add(?:\.js)?$/.test(pathname) ? 'Ürününüz sepete ekleniyor'
          : 'Sepetiniz güncelleniyor';
        if (options.body instanceof FormData) {
          const photoCount = Array.from(options.body.entries()).filter(([name, value]) => (
            name.startsWith('properties[') && name.includes('Fotoğraf')
            && value instanceof File && value.size > 0
          )).length;
          if (photoCount) label = photoCount === 1 ? 'Fotoğrafınız yükleniyor' : 'Fotoğraflarınız yükleniyor';
        }
        return globalThis.RenaoCartProgress.request(url, options, this.form, label);
      }

      async submitWithRenaoProgress(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const personalizerError = this.validateRenaoPersonalizer();
        if (personalizerError) {
          this.handleErrorMessage(personalizerError);
          return;
        }

        const photoQualityError = await this.validateRenaoPhotoQuality();
        if (photoQualityError) {
          this.handleErrorMessage(photoQualityError);
          return;
        }

        this._renaoUnlock = globalThis.RenaoCartProgress.lock(this.form);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const isRenaoEdit = Boolean(this.form.dataset.renaoEditKey);
        const cartTarget = this.getCartTarget(isRenaoEdit);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        globalThis.RenaoCartProgress.stage(this.form, 'Tasarımınız hazırlanıyor…');
        let mapSceneForSubmission = null;
        try {
          const mapRoot = this.form.querySelector('[data-renao-personalizer]');
          if (mapRoot) {
            globalThis.RenaoCartProgress.stage(this.form, 'Haritanız hazırlanıyor…');
            if (typeof mapRoot.renaoPrepareMapScene !== 'function') throw new Error('Harita hazırlanıyor; lütfen tekrar deneyin.');
            mapSceneForSubmission = await mapRoot.renaoPrepareMapScene();
            if (!mapSceneForSubmission) throw new Error('Son harita kaydı eksik; ürün sepete eklenmedi.');
          }
          const managedFileRoots = Array.from(this.form.querySelectorAll('[data-renao-file-managed]'));
          const managedResults = await Promise.allSettled(managedFileRoots.map((root) => (
            typeof root.renaoPrepareManagedFiles === 'function' ? root.renaoPrepareManagedFiles() : Promise.resolve()
          )));
          const failedManaged = managedResults.find(result => result.status === 'rejected');
          if (failedManaged) throw failedManaged.reason;
          const queuedProduction = Boolean(this.form.querySelector(
            '[name="properties[_Renao Üretim]"][value="mac-pdf-v1"]'
          )) && window.RenaoDesignFileLocalOnly !== true;
          if (!queuedProduction) {
            globalThis.RenaoCartProgress.stage(this.form, 'Tasarımınız hazırlanıyor…');
            const preserveBebe4CropRecipe = Boolean(this.form.querySelector(
              '[data-renao-collage-personalizer][data-renao-source-product-handle="bebe4"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe3"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe2"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe"]'
            ));
            if (preserveBebe4CropRecipe) {
              globalThis.RenaoCropRecipe?.syncForm?.(this.form);
            } else if (globalThis.RenaoCropRecipe?.prepareForm) {
              await globalThis.RenaoCropRecipe.prepareForm(this.form);
            } else {
              await globalThis.RenaoCropRecipe?.freezeForm?.(this.form);
            }
            if (globalThis.RenaoDesignFile?.prepareForm) {
              await globalThis.RenaoDesignFile.prepareForm(this.form);
            }
          }
        } catch (error) {
          console.error(error);
          this.handleErrorMessage(error?.message || 'Fotoğraflar baskıya hazırlanamadı. Lütfen tekrar deneyin.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }
        globalThis.RenaoCartProgress.stage(this.form, this._renaoDraftOnly
          ? 'Tasarımınız kaydediliyor…'
          : isRenaoEdit ? 'Sepetiniz güncelleniyor…' : 'Ürününüz sepete ekleniyor…');
        this.prepareRenaoMapDesignInputs();
        const formData = new FormData(this.form);
        if (mapSceneForSubmission) formData.set('properties[_Harita Sahnesi]', mapSceneForSubmission);
        this.appendRenaoManagedFiles(formData);
        // The managed personalizers retain the original source file. Apply the
        // immutable print crop last so it cannot be overwritten before upload.
        this.appendRenaoPendingFiles(formData);
        this.cleanRenaoFormData(formData);
        this.prependRenaoThicknessProperty(formData);
        if (this._renaoDraftOnly) {
          globalThis.RenaoSavedDesign.save(this.form, formData);
          globalThis.RenaoCartProgress.stage(this.form, 'Tasarımınız kaydedildi');
          return;
        }
        globalThis.RenaoSavedDesign?.remember(this.form, formData);
        if (cartTarget) cartTarget.setActiveElement(document.activeElement);
        const giftWrapSelect = this.form.querySelector('[data-renao-gift-wrap-select]');
        const giftWrapVariantId = giftWrapSelect?.selectedOptions?.[0]?.dataset?.variantId;
        const hasRenaoPersonalizer = Boolean(this.form.querySelector(
          '[data-renao-personalizer], [data-renao-music-personalizer], [data-renao-collage-personalizer], [data-renao-netflix-personalizer], [data-renao-nameplate-personalizer], [data-renao-iyiki-personalizer], [data-renao-qr-personalizer], [data-renao-heart-photo-personalizer]'
        ));
        const hasRenaoCollagePersonalizer = Boolean(
          this.form.querySelector('[data-renao-collage-personalizer]')
        );
        const hasFileUploadProperty = this.hasRenaoFileUploadProperty(formData);

        const thicknessVariantChanged = isRenaoEdit
          && Boolean(this.form.closest('product-info')?.querySelector('.renao-baby-thickness'))
          && Number(this.form.dataset.renaoEditKey?.split(':')[0]) !== Number(formData.get('id'));
        if (isRenaoEdit) {
          // Shopify change.js cannot change a line's variant. Use the existing
          // verified add-then-remove flow when the block thickness changes.
          if (hasFileUploadProperty || thicknessVariantChanged) {
            config.body = formData;

            return this.renaoRequest(`${String(routes.cart_add_url || '/cart/add').replace(/\.js$/, '')}.js`, config)
              .then((response) => globalThis.RenaoReadCartJson(response))
              .then((response) => {
                if (response.status) {
                  throw new Error(response.description || response.message || 'Cart add failed');
                }

                globalThis.RenaoCartProgress.stage(this.form, 'Sepetiniz doğrulanıyor…');
            return this.verifyRenaoUploadedFiles(response, formData, cartTarget)
                  .then((verifiedResponse) => this.mirrorRenaoDesignFileProperty(verifiedResponse, formData, cartTarget))
                  .then((mirroredResponse) => this.removeEditedRenaoCartItem(mirroredResponse, cartTarget))
                  .then((cartResponse) => this.addRenaoGiftWrapItem(formData, cartTarget, cartResponse));
              })
              .then((cartResponse) => {
                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'renao-edit',
                    productVariantId: formData.get('id'),
                    cartData: cartResponse,
                  });
                this.error = false;
                globalThis.RenaoCartProgress.success(this.form);
              window.location = window.routes?.cart_url || '/cart';
              })
              .catch((error) => {
                console.error(error);
                this.handleErrorMessage(error?.message || 'Düzenleme kaydedilemedi. Lütfen tekrar deneyin.');
                this.error = true;
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (cartTarget && cartTarget.classList.contains('is-empty')) cartTarget.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
              });
          }

          return this.updateEditedRenaoCartItem(formData, cartTarget)
            .then((cartResponse) => this.addRenaoGiftWrapItem(formData, cartTarget, cartResponse))
            .then((cartResponse) => {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'renao-edit',
                  productVariantId: formData.get('id'),
                  cartData: cartResponse,
              });
              this.error = false;
              globalThis.RenaoCartProgress.success(this.form);
              window.location = window.routes?.cart_url || '/cart';
            })
            .catch((error) => {
              console.error(error);
              this.handleErrorMessage(error?.message || 'Düzenleme kaydedilemedi. Lütfen tekrar deneyin.');
              this.error = true;
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (cartTarget && cartTarget.classList.contains('is-empty')) cartTarget.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }

        if (hasFileUploadProperty) {
          if (hasRenaoCollagePersonalizer && cartTarget) {
            formData.append(
              'sections',
              cartTarget.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        } else if (giftWrapVariantId || hasRenaoPersonalizer) {
          config.headers['Content-Type'] = 'application/json';
          const properties = this.getRenaoPropertiesFromFormData(formData);

          const quantity = Number(formData.get('quantity') || 1);
          const mainItem = {
            id: Number(formData.get('id')),
            quantity,
            properties,
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

          const body = {
            items: [mainItem],
          };

          if (cartTarget) {
            body.sections = cartTarget.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          config.body = JSON.stringify(body);
        } else {
          if (cartTarget) {
            formData.append(
              'sections',
              cartTarget.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        return this.renaoRequest(`${String(routes.cart_add_url || '/cart/add').replace(/\.js$/, '')}.js`, config)
          .then((response) => globalThis.RenaoReadCartJson(response))
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.error = true;
              this.handleErrorMessage(response.description || response.message || 'Ürün sepete eklenemedi.');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!cartTarget) {
              globalThis.RenaoCartProgress.success(this.form);
            window.location = window.routes.cart_url;
              return;
            }

            globalThis.RenaoCartProgress.stage(this.form, 'Sepetiniz doğrulanıyor…');
            return this.verifyRenaoUploadedFiles(response, formData, cartTarget)
              .then((verifiedResponse) => this.mirrorRenaoDesignFileProperty(verifiedResponse, formData, cartTarget))
              .then((mirroredResponse) => this.addRenaoGiftWrapItem(formData, cartTarget, mirroredResponse))
              .then((giftWrapResponse) => this.removeEditedRenaoCartItem(giftWrapResponse, cartTarget))
              .then((cartResponse) => this.verifyRenaoCartItemAdded(cartResponse, formData, {
                useFreshCartItem: hasRenaoCollagePersonalizer,
              }))
              .then((cartResponse) => this.ensureCartSections(cartResponse, cartTarget))
              .then((cartResponse) => {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: cartResponse,
                });
              this.error = false;
              globalThis.RenaoCartProgress.success(this.form);
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      cartTarget.renderContents(cartResponse);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                cartTarget.renderContents(cartResponse);
              }
            });
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(error?.message || 'Sepete eklenemedi. Lütfen tekrar deneyin.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (cartTarget && cartTarget.classList.contains('is-empty')) cartTarget.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getCartTarget(isRenaoEdit = false) {
        if (isRenaoEdit) return document.querySelector('cart-drawer') || this.cart;
        return this.cart;
      }

      hasRenaoFileUploadProperty(formData = null) {
        if (formData) {
          let hasFile = false;
          formData.forEach((value, key) => {
            if (hasFile || !key.startsWith('properties[')) return;
            hasFile = value instanceof File && Boolean(value.name) && value.size > 0;
          });
          if (hasFile) return true;
        }

        if (Array.from(this.form.querySelectorAll('input[type="file"][name^="properties["]'))
          .some((input) => (
            (input.files && input.files.length > 0) ||
            (input.__renaoPendingFile instanceof File && input.__renaoPendingFile.size > 0)
          ))) return true;

        return Array.from(this.form.querySelectorAll('[data-renao-file-managed]'))
          .some((root) => typeof root.renaoHasManagedFiles === 'function' && root.renaoHasManagedFiles());
      }

      appendRenaoPendingFiles(formData) {
        this.form.querySelectorAll('input[type="file"][name^="properties["]').forEach((input) => {
          // Managed personalizers replace their source files with durable URLs
          // in appendRenaoManagedFiles. Never append the same large originals
          // again through the legacy pending-file fallback.
          if (input.closest('[data-renao-file-managed]')) return;
          const file = input.__renaoPendingFile;
          if (!(file instanceof File) || !file.name || file.size <= 0) return;
          formData.delete(input.name);
          formData.append(input.name, file, file.name);
        });
      }

      appendRenaoManagedFiles(formData) {
        this.form.querySelectorAll('[data-renao-file-managed]').forEach((root) => {
          if (typeof root.renaoAppendManagedFiles === 'function') root.renaoAppendManagedFiles(formData);
        });
      }

      verifyRenaoMapProperties(item, formData) {
        if (!this.form.querySelector('[data-renao-personalizer]')) return;
        const expected = this.getRenaoPropertiesFromFormData(formData);
        const fields = ['İsim', 'Tarih', 'Her Şeyin Başladığı Yer', 'Adres Başlığı', 'Koordinat', 'Harita Adresi'];
        if (!item || fields.some((name) => String(item.properties?.[name] ?? '').trim() !== String(expected[name] ?? '').trim())) {
          throw new Error('Harita bilgilerinin kaydı doğrulanamadı. Lütfen sepetinizdeki bilgileri kontrol edin; eksik alan varsa Düzenle ile yeniden kaydedin.');
        }
      }

      verifyRenaoUploadedFiles(response, formData, cartTarget = this.cart) {
        if (this.form.querySelector('[data-renao-personalizer]')) {
          const item = response?.items?.find((item) => Number(item.variant_id || item.id) === Number(formData.get('id'))) || response;
          this.verifyRenaoMapProperties(item, formData);
        }
        const expectedProperties = [];
        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (!propertyMatch || !(value instanceof File) || !value.name || value.size <= 0) return;
          if (propertyMatch[1] === 'Tasarım Dosyası' || propertyMatch[1] === 'Tasarım Önizleme') return;
          expectedProperties.push(propertyMatch[1]);
        });
        if (!expectedProperties.length) return Promise.resolve(response);

        const failedProperties = expectedProperties.filter((propertyName) => {
          const uploadedValue = response?.properties?.[propertyName];
          return typeof uploadedValue !== 'string' || !uploadedValue.trim() || uploadedValue.trim() === 'null';
        });
        if (!failedProperties.length) return Promise.resolve(response);

        const uploadErrorMessage = 'Fotoğraf yüklenemedi. İnternet bağlantınızı kontrol edip fotoğrafı yeniden seçin; ürün sepete eklenmedi.';
        const failedInput = Array.from(this.form.querySelectorAll('input[type="file"][name^="properties["]'))
          .find((input) => failedProperties.some((propertyName) => input.name === `properties[${propertyName}]`));
        const failedPersonalizer = failedInput?.closest(
          '[data-renao-collage-personalizer], [data-renao-netflix-personalizer], [data-renao-music-personalizer], [data-renao-iyiki-personalizer], [data-renao-qr-personalizer], [data-renao-heart-photo-personalizer], [data-renao-simple-photo-upload]'
        );
        failedPersonalizer?.classList.add('has-error', 'has-renao-music-photo-error');
        const inlineError = failedPersonalizer?.querySelector(
          '[data-renao-music-photo-error], [data-renao-collage-error], [data-renao-netflix-error], [data-renao-iyiki-photo-error], [data-renao-qr-photo-error], [data-renao-heart-photo-error], [data-renao-simple-photo-error]'
        );
        if (inlineError) inlineError.textContent = uploadErrorMessage;
        (failedPersonalizer || failedInput)?.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const removeFailedLine = () => {
          if (!response?.key) return Promise.resolve();
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify({
            id: response.key,
            quantity: 0,
            ...this.getCartSectionsPayload(cartTarget),
          });
          return this.renaoRequest(`${routes.cart_change_url}`, config).then((cartResponse) => {
            if (!cartResponse.ok) throw new Error('Eksik fotoğraflı sepet satırı kaldırılamadı.');
            return globalThis.RenaoReadCartJson(cartResponse);
          });
        };

        return removeFailedLine()
          .catch((cleanupError) => {
            console.error('Renao failed upload cart cleanup error.', cleanupError);
          })
          .then(() => {
            throw new Error(uploadErrorMessage);
          });
      }

      getRenaoPhotoQualityRequirement(input) {
        const collage = input.closest('[data-renao-collage-personalizer]');
        if (collage) {
          const count = Math.max(1, Number(collage.dataset.renaoCollagePhotoCount || 6) || 6);
          if (count === 1) return { shortEdge: 600, longEdge: 800 };
          if (count <= 3) return { shortEdge: 450, longEdge: 600 };
          return { shortEdge: 350, longEdge: 450 };
        }

        const netflixSlot = input.dataset.renaoNetflixSlot || '';
        if (netflixSlot.startsWith('small-')) return { shortEdge: 300, longEdge: 400 };
        return { shortEdge: 600, longEdge: 800 };
      }

      readRenaoImageSize(file) {
        this.renaoPhotoQualityCache ||= new WeakMap();
        if (this.renaoPhotoQualityCache.has(file)) return this.renaoPhotoQualityCache.get(file);

        const promise = new Promise((resolve) => {
          if (!(file instanceof File) || !String(file.type || '').startsWith('image/')) {
            resolve(null);
            return;
          }

          const url = URL.createObjectURL(file);
          const image = new Image();
          let finished = false;
          const finish = (size) => {
            if (finished) return;
            finished = true;
            window.clearTimeout(image._renaoQualityTimer);
            URL.revokeObjectURL(url);
            resolve(size);
          };
          image.onload = () => finish({ width: image.naturalWidth, height: image.naturalHeight });
          image.onerror = () => finish(null);
          image._renaoQualityTimer = window.setTimeout(() => finish(null), 2500);
          image.src = url;
        });
        this.renaoPhotoQualityCache.set(file, promise);
        return promise;
      }

      async validateRenaoPhotoQuality() {
        const selectedFiles = Array.from(this.form.querySelectorAll('input[type="file"][name^="properties["]'))
          .filter((input) => !String(input.accept || '').toLowerCase().includes('audio/'))
          .map((input) => ({
            input,
            file: input.__renaoPendingFile || input.files?.[0] || null,
          }))
          .filter(({ file }) => file instanceof File);
        if (!selectedFiles.length) return '';

        const emptyFile = selectedFiles.find(({ file }) => !file.name || file.size <= 0);
        if (emptyFile) return 'Fotoğraf dosyası okunamadı. Lütfen fotoğrafı yeniden seçin.';

        const oversizedFile = selectedFiles.find(({ file }) => file.size > 20 * 1024 * 1024);
        if (oversizedFile) return 'Fotoğraf 20 MB sınırını aşıyor. Lütfen daha küçük bir fotoğraf seçin.';

        const allowedImageTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'image/gif']);
        const allowedImageExtensions = /\.(?:jpe?g|png|webp|heic|heif|gif)$/i;
        const unsupportedFile = selectedFiles.find(({ file }) => (
          !allowedImageTypes.has(String(file.type || '').toLowerCase())
          && !allowedImageExtensions.test(file.name)
        ));
        if (unsupportedFile) return 'Bu fotoğraf biçimi desteklenmiyor. JPEG, PNG, WebP, HEIC veya GIF seçin.';

        const candidates = selectedFiles.filter(({ file }) => String(file.type || '').startsWith('image/'));
        if (!candidates.length) return '';

        const results = await Promise.all(candidates.map(async ({ input, file }) => ({
          input,
          requirement: this.getRenaoPhotoQualityRequirement(input),
          size: await this.readRenaoImageSize(file),
        })));
        const rejected = results.find(({ requirement, size }) => {
          if (!size?.width || !size?.height) return false;
          const shortEdge = Math.min(size.width, size.height);
          const longEdge = Math.max(size.width, size.height);
          return shortEdge < requirement.shortEdge || longEdge < requirement.longEdge;
        });
        if (!rejected) return '';

        const target = rejected.input.closest(
          '[data-renao-collage-personalizer], [data-renao-netflix-personalizer], [data-renao-music-personalizer], [data-renao-iyiki-personalizer], [data-renao-qr-personalizer], [data-renao-heart-photo-personalizer], [data-renao-simple-photo-upload]'
        ) || rejected.input;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return `Seçtiğiniz fotoğraf ${rejected.size.width}×${rejected.size.height} px ve baskı için çok küçük. Lütfen kısa kenarı en az ${rejected.requirement.shortEdge} px, uzun kenarı en az ${rejected.requirement.longEdge} px olan başka bir fotoğraf seçin.`;
      }

      encodeRenaoRecipe(payload) {
        const bytes = new TextEncoder().encode(JSON.stringify(payload));
        let binary = '';
        bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
        return `v1.${btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')}`;
      }

      prepareRenaoMapDesignInputs() {
        const findField = (propertyName) => Array.from(this.form.elements).find(
          (field) => field.name === `properties[${propertyName}]`
        );
        if (!findField('Harita Adresi') && !findField('_Enlem') && !findField('_Boylam')) return;

        const recipeFields = {
          '_Enlem': 'la',
          '_Boylam': 'lo',
          '_Harita Zoom': 'z',
          '_Harita Sahnesi': 'ms',
          '_Kalp X': 'hx',
          '_Kalp Y': 'hy',
          '_Kalp Enlem': 'hla',
          '_Kalp Boylam': 'hlo',
          '_Harita Şekli': 'sh',
          '_Harita Stili': 'st',
          '_Başlık Fontu': 'tf',
          '_İsim Fontu': 'nf',
        };
        const recipe = { m: 'mac-pdf-v1' };
        Object.entries(recipeFields).forEach(([propertyName, shortName]) => {
          const value = String(findField(propertyName)?.value || '').trim();
          if (value) recipe[shortName] = value;
        });

        const ensureHiddenInput = (propertyName) => {
          const inputName = `properties[${propertyName}]`;
          this.form.querySelectorAll(`[name="${inputName}"]`).forEach((field) => {
            if (field.type === 'file') field.disabled = true;
          });
          let input = Array.from(this.form.elements).find(
            (field) => field.name === inputName && field.type === 'hidden'
          );
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = inputName;
            this.form.appendChild(input);
          }
          return input;
        };
        const previewInput = ensureHiddenInput('Tasarım Önizleme');
        const designInput = ensureHiddenInput('Tasarım Dosyası');
        const existingMatch = String(designInput.value || '').match(/\/order-designs\/([a-f0-9-]{36})\/design\.pdf/i)
          || String(previewInput.value || '').match(/\/order-designs\/([a-f0-9-]{36})\/preview\.pdf/i);
        const token = existingMatch?.[1] || this.form.dataset.renaoMapDesignToken || (window.crypto?.randomUUID
          ? window.crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
            const random = Math.floor(Math.random() * 16);
            return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
          }));
        this.form.dataset.renaoMapDesignToken = token;
        const baseUrl = `https://renao-design-files.renaogift.workers.dev/order-designs/${token}`;
        previewInput.value = `${baseUrl}/preview.pdf`;
        designInput.value = `${baseUrl}/design.pdf#r=${this.encodeRenaoRecipe(recipe)}`;
      }

      prepareRenaoQueueProperties(formData) {
        // The map editor is rendered beside (not inside) the native product
        // form in the current product section, so query the page as well.
        const isMapPersonalizer = Boolean(
          this.form.querySelector('[data-renao-personalizer]')
          || document.querySelector('[data-renao-personalizer]')
          || formData.has('properties[_Enlem]')
          || formData.has('properties[_Boylam]')
          || formData.has('properties[_Harita Zoom]')
          || formData.has('properties[Harita Adresi]')
        );
        // Map products are always rendered by the order-design worker. Treat
        // them as queued even if the legacy hidden mode input has not mounted
        // yet; otherwise a fast add-to-cart can race the background PDF upload
        // and lose both public design links.
        const isQueuedProduction = formData.get('properties[_Renao Üretim]') === 'mac-pdf-v1'
          || isMapPersonalizer;
        if (!isQueuedProduction && !isMapPersonalizer) return;

        const recipeFields = {
          '_Renao Üretim': 'm',
          '_Enlem': 'la',
          '_Boylam': 'lo',
          '_Harita Zoom': 'z',
          '_Harita Sahnesi': 'ms',
          '_Kalp X': 'hx',
          '_Kalp Y': 'hy',
          '_Kalp Enlem': 'hla',
          '_Kalp Boylam': 'hlo',
          '_Harita Şekli': 'sh',
          '_Harita Stili': 'st',
          '_Başlık Fontu': 'tf',
          '_İsim Fontu': 'nf',
        };
        const recipe = {};
        const photoPositions = {};

        Object.entries(recipeFields).forEach(([propertyName, shortName]) => {
          const value = String(formData.get(`properties[${propertyName}]`) || '').trim();
          if (value) recipe[shortName] = value;
          formData.delete(`properties[${propertyName}]`);
        });

        if (isMapPersonalizer && !recipe.m) recipe.m = 'mac-pdf-v1';

        Array.from(formData.keys()).forEach((key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          const name = propertyMatch?.[1] || '';
          const positionMatch = name.match(/^_(?:(Ana) |(Küçük )?)?Fotoğraf(?: (\d+))? Konumu$/);
          if (!positionMatch) return;

          const value = String(formData.get(key) || '').trim();
          let shortName = '0';
          if (positionMatch[1]) shortName = 'a';
          else if (positionMatch[2]) shortName = `k${positionMatch[3] || '1'}`;
          else if (positionMatch[3]) shortName = `f${positionMatch[3]}`;
          if (value) photoPositions[shortName] = value;
          formData.delete(key);
        });

        if (Object.keys(photoPositions).length) recipe.p = photoPositions;
        const recipeValue = this.encodeRenaoRecipe(recipe);
        // Shopify Admin shows private line-item properties even when their name
        // starts with an underscore. Carry the compact production recipe inside
        // the already visible design link instead, so every product keeps the
        // same clean order layout without losing edit/render state.
        formData.delete('properties[_Renao Reçete]');

        if (!isQueuedProduction) {
          ['Tasarım Önizleme', 'Tasarım Dosyası'].forEach((propertyName) => {
            const key = `properties[${propertyName}]`;
            const value = formData.get(key);
            if (typeof value !== 'string' || !value.trim()) return;
            formData.set(key, `${value.split('#')[0]}#r=${recipeValue}`);
          });
          return;
        }

        const editProperties = this.getRenaoEditState()?.properties || {};
        const existingPreview = String(editProperties['_Tasarım Önizleme'] || editProperties['Tasarım Önizleme'] || '');
        const existingDesign = String(editProperties['_Tasarım Dosyası'] || editProperties['Tasarım Dosyası'] || '');
        const existingMatch = existingDesign.match(/\/order-designs\/([a-f0-9-]{36})\/design\.pdf/i)
          || existingPreview.match(/\/order-designs\/([a-f0-9-]{36})\/preview\.pdf/i);
        const token = (window.crypto?.randomUUID
          ? window.crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
            const random = Math.floor(Math.random() * 16);
            return (character === 'x' ? random : (random & 0x3) | 0x8).toString(16);
          }));
        const baseUrl = `https://renao-design-files.renaogift.workers.dev/order-designs/${token}`;
        // Keep the compact production recipe in the design URL fragment. The
        // worker can restore it from there without adding a noisy order field.
        formData.set('properties[Tasarım Önizleme]', `${baseUrl}/preview.pdf`);
        formData.set('properties[Tasarım Dosyası]', `${baseUrl}/design.pdf#r=${recipeValue}`);
      }

      cleanRenaoFormData(formData) {
        this.prepareRenaoQueueProperties(formData);
        const hiddenPropertyNames = [];
        const preservedTextPropertyKeys = new Set();
        let hasRenaoDesignFile = false;
        let hasCustomerUploadFile = false;

        formData.forEach((value, key) => {
          if (!(value instanceof File) && String(value || '').trim()) preservedTextPropertyKeys.add(key);
        });

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (!propertyMatch || !(value instanceof File) || !value.name || value.size <= 0) return;
          if (propertyMatch[1] === 'Tasarım Dosyası' || propertyMatch[1] === 'Tasarım Önizleme') hasRenaoDesignFile = true;
          else hasCustomerUploadFile = true;
        });

        const shouldKeepNonFileProperty = (propertyName) => (
          propertyName === 'Hediye Paketi' ||
          propertyName === 'Tasarım' ||
          propertyName === 'Not' ||
          propertyName === 'Sipariş Notu'
        );
        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (!propertyMatch) return;

          const propertyName = propertyMatch[1];
          const textValue = value instanceof File ? value.name : String(value || '').trim();
          if (
            (value instanceof File && (!value.name || value.size <= 0) && !preservedTextPropertyKeys.has(key)) ||
            (propertyName.startsWith('_') && !(this.form.querySelector('[data-renao-derin]') && propertyName.startsWith('_DERİN '))) ||
            propertyName === 'Önizleme' ||
            (!(value instanceof File) && !textValue) ||
            (hasRenaoDesignFile && hasCustomerUploadFile && !(value instanceof File) && !shouldKeepNonFileProperty(propertyName)) ||
            ((propertyName === 'Not' || propertyName === 'Sipariş Notu') && !textValue)
          ) {
            hiddenPropertyNames.push(key);
          }
        });

        hiddenPropertyNames.forEach((key) => formData.delete(key));

        // Shopify hides private line-item properties (keys beginning with an
        // underscore) from cart/checkout while keeping them on the order for
        // production. Privatize customer photo URLs and technical PDF links
        // only after the regular cleanup, which intentionally removes other
        // internal underscore properties after encoding them in the recipe.
        Array.from(formData.entries()).forEach(([key, value]) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          const propertyName = propertyMatch?.[1] || '';
          if (!['Tasarım Önizleme', 'Tasarım Dosyası', 'Albüm Görseli', 'Spotify Kodu', 'Şarkı Linki'].includes(propertyName) && !/^Fotoğraf(?: \d+)?$/.test(propertyName)) return;
          formData.set(`properties[_${propertyName}]`, value);
          formData.delete(key);
        });
      }

      prependRenaoThicknessProperty(formData) {
        const productInfo = this.form.closest('product-info');
        const fieldset = productInfo?.querySelector('.renao-baby-thickness');
        if (!fieldset) return;
        const selected = productInfo.querySelector('variant-selects [data-selected-variant]');
        let variant;
        try { variant = JSON.parse(selected?.textContent || 'null'); } catch { return; }
        if (!variant || String(variant.id) !== String(formData.get('id'))) return;
        const thickness = String(fieldset.querySelector('input:checked')?.value || '').match(/^([23])\s*cm\b/i)?.[1];
        if (!thickness || !variant.options?.some((value) => String(value).startsWith(`${thickness} cm`))) return;
        const entries = Array.from(formData.entries()).filter(([key]) => key !== 'properties[ÜRÜN]');
        Array.from(new Set(Array.from(formData.keys()))).forEach((key) => formData.delete(key));
        formData.append('properties[ÜRÜN]', `${thickness} CM`);
        entries.forEach(([key, value]) => formData.append(key, value));
      }

      getRenaoPropertiesFromFormData(formData) {
        const preserveIsoBabyDate = Boolean(this.form.querySelector(
          '[data-renao-collage-personalizer][data-renao-source-product-handle="bebe4"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe3"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe2"], [data-renao-collage-personalizer][data-renao-source-product-handle="bebe"]'
        ));
        const rawProperties = {};
        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (value instanceof File && !value.name && value.size === 0) return;
          if (!propertyMatch) return;

          const propertyName = propertyMatch[1];
          const isPrivateProductionProperty = (this.form.querySelector('[data-renao-derin]') && propertyName.startsWith('_DERİN ')) || ['_Tasarım Önizleme', '_Tasarım Dosyası', '_Albüm Görseli', '_Spotify Kodu', '_Şarkı Linki'].includes(propertyName)
            || /^_Fotoğraf(?: \d+)?$/.test(propertyName);
          if ((propertyName.startsWith('_') && !isPrivateProductionProperty) || propertyName === 'Önizleme') return;
          if ((propertyName === 'Not' || propertyName === 'Sipariş Notu') && !String(value || '').trim()) return;
          if (value) rawProperties[propertyName] = value;
        });

        const formatPropertyValue = (key, value) => {
          if (key === 'Tarih' && !preserveIsoBabyDate) {
            const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;
          }
          return value;
        };

        const properties = {};
        const orderedKeys = [
          'ÜRÜN',
          'Tasarım',
          'Harita Adresi',
          'Tarih',
          'Her Şeyin Başladığı Yer',
          'İsim',
          'Adres Başlığı',
	          'Koordinat',
	          'İsim Soyisim',
          'Ünvan',
          'İsim Fontu',
          'Ünvan Fontu',
          'Yazı Rengi',
	          'Not',
	          'Alt Not Fontu',
	          'QR Kod',
	          'Sipariş Notu',
          'Hediye Paketi',
          'Fotoğraf',
          'Ses Dosyası',
          'Premium Ses Dalgası',
          'Görsel Tercihi',
          'Kod Tipi',
          'Şarkı Adı',
          'Şarkı Linki',
          'Başlangıç Zamanı',
          'Şarkı Süresi',
          'Başlık',
          'Başlık Fontu',
          'Tasarım Önizleme',
          'Tasarım Dosyası',
        ];

        orderedKeys.forEach((key) => {
          if (rawProperties[key] !== undefined) properties[key] = formatPropertyValue(key, rawProperties[key]);
        });

        Object.entries(rawProperties).forEach(([key, value]) => {
          if (properties[key] === undefined) properties[key] = formatPropertyValue(key, value);
        });

        return properties;
      }

      getCartSectionsPayload(cartTarget) {
        if (!cartTarget) return {};

        return {
          sections: cartTarget.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        };
      }

      verifyRenaoCartItemAdded(response, formData, { useFreshCartItem = false } = {}) {
        const expectedVariantId = Number(formData.get('id'));
        const designFileValue = formData.get('properties[_Tasarım Dosyası]') || formData.get('properties[Tasarım Dosyası]');
        const expectedDesignFile = designFileValue instanceof File ? '' : String(designFileValue || '').trim();
        const expectedItemKey = String(response?.key || '');
        if (!expectedVariantId) return Promise.resolve(response);

        const cartUrl = `${window.routes?.cart_url || '/cart'}.js?renao_verify=${Date.now()}`;
        return this.renaoRequest(cartUrl, {
          cache: 'no-store',
          headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
        })
          .then((cartResponse) => {
            if (!cartResponse.ok) throw new Error('Sepet doğrulanamadı. Lütfen tekrar deneyin.');
            return globalThis.RenaoReadCartJson(cartResponse);
          })
          .then((cartState) => {
            const addedItem = cartState.items?.find((item) => expectedItemKey && item.key === expectedItemKey)
              || cartState.items?.find((item) => (
              Number(item.variant_id) === expectedVariantId &&
              (!expectedDesignFile || item.properties?.['_Tasarım Dosyası'] === expectedDesignFile || item.properties?.['Tasarım Dosyası'] === expectedDesignFile)
              ));
            if (!addedItem) {
              throw new Error('Ürün sepete kaydedilemedi. Lütfen tekrar deneyin.');
            }
            this.verifyRenaoMapProperties(addedItem, formData);
            if (!useFreshCartItem) return response;
            return {
              ...response,
              ...cartState,
              key: addedItem.key,
              sections: response?.sections,
            };
          });
      }

      ensureCartSections(response, cartTarget = this.cart) {
        if (!cartTarget || response?.sections) return Promise.resolve(response);

        const sectionIds = cartTarget.getSectionsToRender().map((section) => section.id).join(',');
        if (!sectionIds) return Promise.resolve(response);

        const url = `${window.routes?.cart_url || '/cart'}?sections=${encodeURIComponent(sectionIds)}&sections_url=${encodeURIComponent(window.location.pathname)}`;

        return this.renaoRequest(url, {
          headers: { Accept: 'application/json' },
        })
          .then((sectionResponse) => globalThis.RenaoReadCartJson(sectionResponse))
          .then((sections) => ({
            ...response,
            sections,
          }))
          .catch((error) => {
            console.warn('Cart sections could not be refreshed after add.', error);
            return response;
          });
      }

      mirrorRenaoDesignFileProperty(response, formData, cartTarget = this.cart) {
        const properties = response?.properties;
        const designUrl = properties?.['_Tasarım Dosyası'] || properties?.['Tasarım Dosyası'];
        if (!response?.key || !designUrl || properties?.['_Tasarım Önizleme'] || properties?.['Tasarım Önizleme']) return Promise.resolve(response);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          id: response.key,
          quantity: Number(response.quantity || formData.get('quantity') || 1),
          properties: {
            ...properties,
            '_Tasarım Önizleme': designUrl,
          },
          ...this.getCartSectionsPayload(cartTarget),
        });

        return this.renaoRequest(`${routes.cart_change_url}`, config)
          .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
          .then((cartState) => {
            if (cartState.errors || cartState.status) throw new Error(cartState.description || cartState.message || 'Design preview property could not be mirrored.');
            return cartState;
          })
          .catch((error) => {
            console.warn('Renao design preview property could not be mirrored; the editable design file is still attached.', error);
            return response;
          });
      }

      async addRenaoGiftWrapItem(formData, cartTarget = this.cart, previousResponse = null) {
        try {
          if (!window.RenaoGiftWrap) throw new Error('Hediye paketi hizmeti yüklenemedi.');
          const { cart, changed } = await window.RenaoGiftWrap.sync(this.getCartSectionsPayload(cartTarget));
          const result = { ...previousResponse, ...cart, key: previousResponse?.key };
          if (!changed) result.sections = previousResponse?.sections;
          return this.ensureCartSections(result, cartTarget);
        } catch (error) {
          throw new Error('Ürün kaydedildi ancak hediye paketi doğrulanamadı. Sepetinize gidip ödeme adımını yeniden deneyin.');
        }
      }

      updateEditedRenaoCartItem(formData, cartTarget = this.cart) {
        const editKey = this.form.dataset.renaoEditKey;
        if (!editKey) return Promise.reject(new Error('Edited cart key is missing'));

        // Shopify replaces the complete line-item properties object on
        // /cart/change.js. Merge the original edit state first so unchanged
        // customer-upload URLs cannot disappear when only caption, crop or
        // gift-wrap fields are edited.
        const originalProperties = this.getRenaoEditState(editKey)?.properties || {};
        const currentProperties = this.getRenaoPropertiesFromFormData(formData);
        const isMapEdit = Boolean(document.querySelector('[data-renao-personalizer]'));
        const properties = isMapEdit ? { ...currentProperties } : { ...(currentProperties['ÜRÜN'] ? { 'ÜRÜN': currentProperties['ÜRÜN'] } : {}), ...originalProperties, ...currentProperties };
        // Edit snapshots contain decoded recipe fields and legacy public URLs.
        // Keep only the newly serialized recipe and one canonical URL per asset.
        Object.keys(properties).forEach((name) => {
          if (name === '_Renao Reçete' || name === '_Renao Üretim' || /^_(?:(?:Ana|Küçük) )?Fotoğraf(?: \d+)? Konumu$/.test(name)) {
            delete properties[name];
          }
          if (/^(?:Fotoğraf(?: \d+)?|Tasarım Dosyası|Tasarım Önizleme|Albüm Görseli|Spotify Kodu|Şarkı Linki)$/.test(name) && currentProperties[`_${name}`] !== undefined) {
            delete properties[name];
          }
        });
        // Empty editable text means the customer cleared it, not keep old text.
        this.form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach((input) => {
          const name = input.name.match(/^properties\[(.+)\]$/)?.[1];
          if (name && input.type !== 'file' && !input.disabled && !name.startsWith('_') && !String(input.value || '').trim()) delete properties[name];
        });
        const quantity = Number(formData.get('quantity') || 1);
        const sectionPayload = this.getCartSectionsPayload(cartTarget);

        const buildChangeConfig = (payload) => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify({
            ...payload,
            quantity,
            properties,
            ...sectionPayload,
          });
          return config;
        };

        const cleanEditState = (cartState) => {
          const storageKey = this.form.dataset.renaoEditStorageKey;
          if (storageKey) window.sessionStorage.removeItem(storageKey);

          const url = new URL(window.location.href);
          if (url.searchParams.has('renao_edit')) {
            url.searchParams.delete('renao_edit');
            window.history.replaceState({}, '', url.toString());
          }

          this.form.removeAttribute('data-renao-edit-key');
          this.form.removeAttribute('data-renao-edit-storage-key');
          if (this.submitButtonText && window.variantStrings?.addToCart) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }

          return cartState;
        };

        const changeByPayload = (payload) => this.renaoRequest(`${routes.cart_change_url}`, buildChangeConfig(payload))
          .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
          .then((cartState) => {
            if (cartState.errors) {
              throw new Error(typeof cartState.errors === 'string' ? cartState.errors : 'Cart change failed');
            }
            if (this.form.querySelector('[data-renao-personalizer]')) {
              const expectedDesign = currentProperties['_Tasarım Dosyası'] || currentProperties['Tasarım Dosyası'];
              const item = cartState.items?.find((item) => Number(item.variant_id) === Number(formData.get('id')) &&
                (!expectedDesign || (item.properties?.['_Tasarım Dosyası'] || item.properties?.['Tasarım Dosyası']) === expectedDesign));
              this.verifyRenaoMapProperties(item, formData);
            }
            return cleanEditState(cartState);
          });

        return this.renaoRequest(`${window.routes?.cart_url || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
          .then((cartState) => {
            const lineIndex = cartState.items.findIndex((item) => item.key === editKey);
            if (lineIndex === -1) throw new Error('Edited cart line was not found');
            return changeByPayload({ line: lineIndex + 1 });
          })
          .catch((lineError) => {
            console.warn('Renao edited cart item could not be updated by line.', lineError);
            return changeByPayload({ id: editKey });
          });
      }

      getRenaoEditState(editKey = this.form.dataset.renaoEditKey) {
        const storageKey = this.form.dataset.renaoEditStorageKey || (editKey ? `renaoCartEdit:${editKey}` : '');
        if (!storageKey) return null;

        try {
          const editState = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
          if (!editState) return null;
          return editState;
        } catch (error) {
          console.warn('Renao edit state could not be read.', error);
          return null;
        }
      }

      removeEditedRenaoCartItem(response, cartTarget = this.cart) {
        const editKey = this.form.dataset.renaoEditKey;
        if (!editKey) return Promise.resolve(response);
        const editState = this.getRenaoEditState(editKey);

        const buildCartChangeConfig = (payload) => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';

          const body = {
            ...payload,
            quantity: 0,
          };

          if (cartTarget) {
            body.sections = cartTarget.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          config.body = JSON.stringify(body);
          return config;
        };

        const propertiesMatchEditedItem = (item) => {
          const originalProperties = editState?.properties || {};
          const currentProperties = item?.properties || {};
          if (!Object.keys(originalProperties).length) return false;

          const originalDesignFile = originalProperties['Tasarım Dosyası'] || originalProperties['_Tasarım Dosyası'];
          if (
            originalDesignFile &&
            (currentProperties['Tasarım Dosyası'] === originalDesignFile || currentProperties['_Tasarım Dosyası'] === originalDesignFile)
          ) return true;

          const comparableKeys = Object.keys(originalProperties)
            .filter((key) => key && key.charAt(0) !== '_' && originalProperties[key] !== '');
          if (!comparableKeys.length) return false;

          return comparableKeys.every((key) => currentProperties[key] === originalProperties[key]);
        };

        const findEditedLineIndex = (cartState) => {
          const items = cartState?.items || [];
          let lineIndex = items.findIndex((item) => item.key === editKey);
          if (lineIndex !== -1) return lineIndex;

          lineIndex = items.findIndex((item) => (
            (!editState?.variantId || Number(item.variant_id) === Number(editState.variantId)) &&
            propertiesMatchEditedItem(item)
          ));
          return lineIndex;
        };

        const removeByPayload = (payload) => this.renaoRequest(`${routes.cart_change_url}`, buildCartChangeConfig(payload))
          .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
          .then((cartState) => {
            if (cartState.errors) {
              throw new Error(typeof cartState.errors === 'string' ? cartState.errors : 'Cart change failed');
            }
            return cartState;
          });

        const removeByLine = () => this.renaoRequest(`${window.routes?.cart_url || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
          .then((cartState) => {
            const lineIndex = findEditedLineIndex(cartState);
            if (lineIndex === -1) throw new Error('Edited cart line was not found');
            return removeByPayload({ line: lineIndex + 1 });
          });

        const removeByUpdate = () => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';

          const body = {
            updates: {
              [editKey]: 0,
            },
          };

          if (cartTarget) {
            body.sections = cartTarget.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          config.body = JSON.stringify(body);

          return this.renaoRequest(`${window.routes?.cart_update_url || '/cart/update.js'}`, config)
            .then((cartResponse) => globalThis.RenaoReadCartJson(cartResponse))
            .then((cartState) => {
              if (cartState.errors) {
                throw new Error(typeof cartState.errors === 'string' ? cartState.errors : 'Cart update failed');
              }
              return cartState;
            });
        };

        return removeByLine()
          .catch((lineError) => {
            console.warn('Renao edited cart item could not be removed by line.', lineError);
            return removeByPayload({ id: editKey });
          })
          .catch((keyError) => {
            console.warn('Renao edited cart item could not be removed by key.', keyError);
            return removeByUpdate();
          })
          .then((cartState) => {
            const storageKey = this.form.dataset.renaoEditStorageKey;
            if (storageKey) window.sessionStorage.removeItem(storageKey);

            const url = new URL(window.location.href);
            if (url.searchParams.has('renao_edit')) {
              url.searchParams.delete('renao_edit');
              window.history.replaceState({}, '', url.toString());
            }

            this.form.removeAttribute('data-renao-edit-key');
            this.form.removeAttribute('data-renao-edit-storage-key');
            this.form.querySelector('[data-renao-edit-token-property]')?.remove();
            if (this.submitButtonText && window.variantStrings?.addToCart) {
              this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
            return cartState;
          })
          .catch((error) => {
            console.warn('Renao edited cart item could not be removed.', error);
            return response;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (errorMessage) globalThis.RenaoCartProgress.fail(this.form, errorMessage, Boolean(this.form.__renaoCartUncertain));
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateRenaoPersonalizer() {
        const magnet = this.form.querySelector('[data-renao-magnet]');
        if (magnet) {
          const error = magnet.renaoValidate?.() || (!magnet.renaoValidate ? 'Fotoğraf alanları yükleniyor. Lütfen tekrar deneyin.' : '');
          if (error) return error;
        }
        const arkadas = this.form.querySelector('[data-arkadas-fields]');
        if (arkadas) {
          const error = arkadas.renaoValidate?.() || (!arkadas.renaoValidate ? 'Kişiselleştirme yükleniyor. Lütfen tekrar deneyin.' : '');
          if (error) return error;
        }
        const simplePhotoUpload = this.form.querySelector('[data-renao-simple-photo-upload]');
        if (simplePhotoUpload) {
          const simplePhotoInput = simplePhotoUpload.querySelector('input[type="file"][name="properties[Fotoğraf]"]');
          const existingPhotoInput = simplePhotoUpload.querySelector('[data-renao-simple-existing-photo]');
          const hasNewPhoto = Boolean(simplePhotoInput?.files && simplePhotoInput.files.length > 0);
          const hasExistingPhoto = Boolean(existingPhotoInput?.value);
          const missingPhoto = !(hasNewPhoto || hasExistingPhoto);
          simplePhotoUpload.classList.toggle('has-error', missingPhoto);

          if (missingPhoto) {
            simplePhotoUpload.scrollIntoView({ behavior: 'smooth', block: 'center' });
            window.setTimeout(() => simplePhotoInput?.focus?.({ preventScroll: true }), 280);
            return 'Fotoğraf eklemeden sepete ekleyemezsin.';
          }
        }

        const netflixPersonalizer = this.form.querySelector('[data-renao-netflix-personalizer]');
        if (netflixPersonalizer) {
          const missingInputs = Array.from(
            netflixPersonalizer.querySelectorAll('[data-renao-netflix-photo-input]')
          ).filter((input) => {
            const hasNewFile = Boolean(input.files && input.files.length > 0);
            const hasExistingPhoto = Boolean(
              input
                .closest('[data-renao-netflix-upload]')
                ?.querySelector('[data-renao-netflix-existing-photo]:not(:disabled)')
                ?.value
            );
            return !(hasNewFile || hasExistingPhoto);
          });

          netflixPersonalizer.classList.toggle('has-error', missingInputs.length > 0);
          netflixPersonalizer.querySelectorAll('[data-renao-netflix-upload]').forEach((upload) => {
            const input = upload.querySelector('[data-renao-netflix-photo-input]');
            upload.classList.toggle('has-error', missingInputs.includes(input));
          });

          if (missingInputs.length > 0) {
            netflixPersonalizer.dispatchEvent(new CustomEvent('renao:netflix:invalid', {
              bubbles: true,
              detail: { missingInputs },
            }));
            netflixPersonalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const focusTarget = missingInputs[0]
              ?.closest('[data-renao-netflix-upload]')
              ?.querySelector('[data-renao-netflix-photo-button]');
            window.setTimeout(() => focusTarget?.focus?.({ preventScroll: true }), 280);
            return netflixPersonalizer.dataset.renaoNetflixMissingMessage || '4 fotoğrafı da eklemeden sepete ekleyemezsin.';
          }
        }

        const musicPersonalizer = this.form.querySelector('[data-renao-music-personalizer]');
        if (musicPersonalizer) {
          const musicPhotoInput = musicPersonalizer.querySelector('[data-renao-music-photo-input]');
          const existingPhotoInput = this.form.querySelector('[data-renao-music-existing-photo-property]');
          const hasNewPhoto = Boolean(musicPhotoInput?.files && musicPhotoInput.files.length > 0);
          const hasExistingPhoto = Boolean(existingPhotoInput?.value || musicPersonalizer.dataset.renaoExistingPhoto === 'true');
          const missingPhoto = !(hasNewPhoto || hasExistingPhoto);

          musicPersonalizer.classList.toggle('has-renao-music-photo-error', missingPhoto);

          if (missingPhoto) {
            musicPersonalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const focusTarget = musicPersonalizer.querySelector('[data-renao-music-photo-button]');
            window.setTimeout(() => focusTarget?.focus?.({ preventScroll: true }), 280);
            return 'Fotoğraf seçmeden sepete ekleyemezsin.';
          }
        }

        const nameplatePersonalizer = this.form.querySelector('[data-renao-nameplate-personalizer]');
        if (nameplatePersonalizer) {
          const validationEvent = new CustomEvent('renao:nameplate:validate', {
            bubbles: true,
            detail: { valid: true },
          });
          nameplatePersonalizer.dispatchEvent(validationEvent);
          if (!validationEvent.detail.valid) {
            nameplatePersonalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return 'İsim soyisim ve ünvan alanlarını doldurun.';
          }
        }

        const iyikiPersonalizer = this.form.querySelector('[data-renao-iyiki-personalizer]');
        if (iyikiPersonalizer) {
          const validationEvent = new CustomEvent('renao:iyiki:validate', {
            bubbles: true,
            detail: { valid: true },
          });
          iyikiPersonalizer.dispatchEvent(validationEvent);
          if (!validationEvent.detail.valid) {
            iyikiPersonalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return 'Fotoğraf, tarih ve isim alanlarını doldurun.';
          }
        }

        const qrPersonalizer = this.form.querySelector('[data-renao-qr-personalizer]');
        if (qrPersonalizer) {
          const validationEvent = new CustomEvent('renao:qr:validate', {
            bubbles: true,
            detail: { valid: true },
          });
          qrPersonalizer.dispatchEvent(validationEvent);
          if (!validationEvent.detail.valid) {
            qrPersonalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const focusTarget = validationEvent.detail.focusSelector
              ? qrPersonalizer.querySelector(validationEvent.detail.focusSelector)
              : qrPersonalizer.querySelector('[data-renao-qr-photo-button]');
            window.setTimeout(() => focusTarget?.focus?.({ preventScroll: true }), 280);
            return validationEvent.detail.message || 'Fotoğraf seçmeden sepete ekleyemezsin.';
          }
        }

        const personalizer = this.form.querySelector('[data-renao-personalizer]');
        if (!personalizer) return '';

        const missingShape = personalizer.dataset.renaoShapeSelected !== 'true';
        const missingLocation = personalizer.dataset.renaoLocationSelected !== 'true';

        personalizer.classList.toggle('has-renao-shape-error', missingShape);
        personalizer.classList.toggle('has-renao-location-error', missingLocation);

        if (!missingShape && !missingLocation) return '';

        const target = missingShape
          ? personalizer.querySelector('[data-renao-shape]')
          : personalizer.querySelector('[data-renao-preview-address-input]');

        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!missingShape) target?.focus({ preventScroll: true });

        if (missingShape && missingLocation) return 'Lütfen harita şeklini seçin ve konumunuzu listeden belirleyin.';
        if (missingShape) return 'Lütfen harita şeklini seçin.';
        return 'Lütfen konumunuzu arama sonuçlarından seçin.';
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
